import { createReducer, createActions } from 'reduxsauce';
import Cookies from 'js-cookie';
import get from 'lodash/get';

/* --------------------- Types and Action Creators ---------------- */
const { Types, Creators } = createActions({
    setUser: ['user'],
    setDatabaseName: ['databaseName'],
    setPageTitle: ['pageTitle'],
    setSmallPageTitle: ['smallPageTitle'],
    setSettings: ['settings'],
    setBaseYear: ['baseYear'],
});

export const MainTypes = Types;

Creators.setLogin = user => {
	return dispatch => {
        if (user.token) {
            Cookies.set('camra-token', user.token);
        }
        return Promise.resolve(dispatch(Creators.setUser(user)));
    };
};

Creators.setLogout = () => {
    return dispatch => {
        Cookies.remove('camra-token');
        return Promise.resolve(dispatch(Creators.setUser(null)));
    };
};

export default Creators;

/* --------------------- Selectors ---------------- */
export const MainSelectors = {
    selectToken: state => state.main.token,
    selectUser: state => state.main.user,
    selectLoggedIn: state => !!get(state, 'main.user'),
    selectDatabaseName: state => state.main.databaseName,
    selectPageTitle: state => state.main.pageTitle,
    selectSmallPageTitle: state => state.main.smallPageTitle,
    selectSettings: state => state.main.settings,
    selectNotifications: state => state.main.notifications,
    selectBaseYear: state => state.main.baseYear,
};

/* --------------------- Initial State ----------------- */
export const INITIAL_STATE = {
    user: null,
    databaseName: '',
    pageTitle: '',
    smallPageTitle: '',
    settings: {},
    baseYear: 2022,
};

/* ------------------- Reducers --------------------- */
export const setUser = (state, { user }) => ({
    ...state,
    user
});

export const setDatabaseName = (state, { databaseName }) => ({
    ...state,
    databaseName
});

export const setPageTitle = (state, { pageTitle }) => ({
    ...state,
    pageTitle
});

export const setSmallPageTitle = (state, { smallPageTitle }) => ({
    ...state,
    smallPageTitle
});

export const setSettings = (state, { settings }) => ({
    ...state,
    settings
});

export const setBaseYear = (state, { baseYear }) => ({
    ...state,
    baseYear
});

export const reducer = createReducer(INITIAL_STATE, {
    [Types.SET_USER]: setUser,
    [Types.SET_DATABASE_NAME]: setDatabaseName,
    [Types.SET_PAGE_TITLE]: setPageTitle,
    [Types.SET_SMALL_PAGE_TITLE]: setSmallPageTitle,
    [Types.SET_SETTINGS]: setSettings,
    [Types.SET_BASE_YEAR]: setBaseYear,
});
